import React, { PropTypes } from 'react'
import Link from 'react-router/lib/Link'

const Sent  = ({ email }) => {
  return (
    <div>
      <hr />
      <p>Your password reset code has been sent to <strong className="text-info">{email}</strong>.</p>
      <hr />
      <Link to="/login" className="btn-link"><em>&larr; Back to Login</em></Link>
    </div>
  )
}

Sent.propTypes = {
  email: PropTypes.string,
}

export default Sent



// WEBPACK FOOTER //
// ./src/containers/Auth/ForgotPassword/sent.js